module.exports = __webpack_public_path__ + "static/media/book-full-bg.444dd11b.jpg";